import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"
import spanish from "./locales/es.json"

// A context key such as "Open Discord_server" has no English entry, so English falls back to its
// base key ("Open Discord") and only Spanish words it differently.
const english = Object.fromEntries(
  Object.keys(spanish)
    .filter((key) => !/_[a-z]+$/.test(key))
    .map((key) => [key, key]),
)

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    keySeparator: false,
    resources: {
      en: {
        translation: english,
      },
      es: {
        translation: spanish,
      },
    },
    supportedLngs: ["en", "es"],
  })

function updateDocumentLanguage(language: string) {
  document.documentElement.lang = language.startsWith("es") ? "es" : "en"
}

updateDocumentLanguage(i18n.resolvedLanguage ?? i18n.language)
i18n.on("languageChanged", updateDocumentLanguage)

export default i18n
